import { useEffect, useState } from "react";
//#region Components
import CustomTableList from "components/CustomTableList/CustomTableList";
import TableListItem from "./TableListItem/TableListItem";
//#endregion
//#region Utils
import { Container } from "./styles";
import { RESOURCES_CONSTANTS } from "config/constants";
import { HEADERS_TABLE_LIST } from "./constants";
//#endregion

const { RESOURCE_TYPES_IDS } = RESOURCES_CONSTANTS;

const HistoryTable = ({
    changeHistory,
    resourceTypeId
}) => {
    //#region States
    const [headers, setHeaders] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        if (changeHistory.length === 0) return;
        fillHeaders();
    }, [changeHistory]);
    //#endregion
    //#region Functions
    const fillHeaders = () => {
        let newHeaders = HEADERS_TABLE_LIST[resourceTypeId];
        if (resourceTypeId === RESOURCE_TYPES_IDS.GROUP_ROOM) 
            newHeaders = newHeaders.filter(({ title }) => {
                const { environment, address } = changeHistory[0];
                if (title === "Nombre" && !environment) return false;
                if (title === "Dirección" && !environment) return false;
                return true;
            });
        setHeaders(newHeaders);
    }
    //#endregion
    const Item = ({
        [RESOURCE_TYPES_IDS.TABLET]: TableListItem.Tablet,
        [RESOURCE_TYPES_IDS.PC]: TableListItem.PC,
        [RESOURCE_TYPES_IDS.GROUP_ROOM]: TableListItem.GroupRoom
    })[resourceTypeId];
    return (
        <Container>
            <CustomTableList 
                minWidth="600px" 
                maxHeight="38vh"
                scrollColor="secondary"
                variant="secondary"
                headers={headers}>
                {changeHistory?.map((item, idx) => (
                    <Item key={idx} {...item}/>
                ))}
            </CustomTableList>
        </Container>
    );
}

export default HistoryTable;